export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5274';

// Every admin is an internal user, and the load balancer routes requests carrying this
// header to pre-prod while a pre-prod deploy is live, the same way it routes internal
// desktop users
const INTERNAL_USER_HEADER = 'x-internal-user';

// The load balancer sends requests carrying this header to the TypeScript api,
// as it does for apps whose user is on TypeScript. Every admin is staff, and
// staff are on TypeScript. The api serves the admin routes it has ported, the
// cutover's among them, and forwards the rest to Python, which still serves
// nudges, agent changes and broadcasts
const TYPESCRIPT_BACKEND_HEADER = 'x-lb-backend';

// fetch for backend requests: all admin calls to the API go through here
export const apiFetch = (
  url: string,
  init?: RequestInit
): Promise<Response> => {
  const headers = new Headers(init?.headers);
  headers.set(INTERNAL_USER_HEADER, 'true');
  headers.set(TYPESCRIPT_BACKEND_HEADER, 'ts');
  return fetch(url, { ...init, headers });
};
